import { businessHours } from '../../../mocks/businessHours';

export default function LocationHours() {
  const currentDay = new Date().toLocaleDateString('en-US', { weekday: 'long' });

  return (
    <section id="location" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-11 gap-8">
          {/* Map Area */}
          <div className="md:col-span-6">
            <div className="relative h-full min-h-[500px] rounded-2xl overflow-hidden border border-gray-200 shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2412648718453!2d-73.98823492346679!3d40.75889497138558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25855c6480299%3A0x55194ec5a1ae072e!2sTimes%20Square!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Restaurant Location"
              ></iframe>
              <a 
                href="https://maps.google.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="absolute bottom-6 left-6 px-6 py-3 bg-red-700 text-white rounded-full font-semibold hover:bg-red-800 transition-all shadow-lg flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-pin-line"></i>
                Get Directions
              </a>
            </div>
          </div>

          {/* Information Area */}
          <div className="md:col-span-5 flex flex-col justify-center">
            {/* Address Block */}
            <div className="mb-10">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-red-700 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Visit Us</h3>
                  <p className="text-gray-700 leading-relaxed">
                    123 Culinary Street<br />
                    Downtown District<br />
                    New York, NY 10001
                  </p>
                  <a href="tel:+15551234567" className="inline-block mt-3 text-red-700 font-semibold hover:text-red-800 cursor-pointer">
                    <i className="ri-phone-line mr-1"></i>
                    (555) 123-4567
                  </a>
                </div>
              </div>
            </div>

            {/* Hours Block */}
            <div className="mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full flex-shrink-0">
                  <i className="ri-time-line text-red-700 text-xl"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Hours</h3>
                  <div className="space-y-2">
                    {businessHours.map((day, index) => (
                      <div 
                        key={index}
                        className={`flex justify-between py-2 px-3 rounded-lg transition-colors ${
                          day.day === currentDay ? 'bg-red-50' : ''
                        }`}
                      >
                        <span className={`font-medium ${day.day === currentDay ? 'text-red-700' : 'text-gray-700'}`}>
                          {day.day}
                        </span>
                        <span className={`${day.day === currentDay ? 'text-red-700 font-semibold' : 'text-gray-600'}`}>
                          {day.hours}
                        </span>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-gray-500 italic mt-3">
                    *Hours may vary on holidays
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="flex gap-3">
              <a 
                href="tel:+15551234567"
                className="flex-1 px-6 py-3 border-2 border-red-700 text-red-700 rounded-full font-semibold hover:bg-red-700 hover:text-white transition-all text-center flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                Call
              </a>
              <a 
                href="#menu"
                className="flex-1 px-6 py-3 border-2 border-red-700 text-red-700 rounded-full font-semibold hover:bg-red-700 hover:text-white transition-all text-center flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-restaurant-line"></i>
                Order Online
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}